import type { ReactNode } from 'react';
import { rowButton } from '../lib/rowButton';

/**
 * A risk/attention list row (CW-12): the `flagged-item` <li> wrapper + keyboard-accessible click behaviour
 * (via the ONE shared `rowButton` helper) in a single place, so every risk list — the money-ranked cockpit
 * «کارهای امروز», margin-at-risk, overdue tranches, credit flags, the flagged worklist — renders and behaves
 * identically, and a new row can't forget the Enter/Space handler (the a11y drift the dashboard used to
 * re-introduce with every hand-rolled copy). Content is a slot; pass `onActivate` for a clickable row, omit
 * it for a static one.
 */
export function AttentionRow({
  onActivate,
  className,
  children,
}: {
  onActivate?: (() => void) | undefined;
  className?: string;
  children: ReactNode;
}) {
  const cls = `flagged-item${onActivate ? ' is-link' : ''}${className ? ` ${className}` : ''}`;
  return onActivate ? (
    <li className={cls} {...rowButton(onActivate)}>
      {children}
    </li>
  ) : (
    <li className={cls}>{children}</li>
  );
}
